import { getVehicleTags } from '@cinch-labs/shared-util'
import type { DirectVehicleAdvertSummary } from '@cinch-nx/data-vehicle'

import { ProductListCard } from './components/product-list-card/product-list-card'

export interface VehicleCardProps {
  id: string
  isSaved: boolean
  isPending: boolean
  isUnfavourited?: boolean
  linkToProductView?: boolean
  isAvailable?: boolean
  vehicle: DirectVehicleAdvertSummary
  onSave?: (newVal: boolean) => void
}

export const VehicleCard: React.FC<VehicleCardProps> = ({
  vehicle,
  id,
  ...props
}) => {
  const {
    vehicleId,
    price,
    variant,
    make,
    selectedModel,
    isReserved,
    quoteRegularPaymentInPence,
    quoteType,
    vehicleYear,
    thumbnailUrl,
    discountInPence,
    priceIncludingAdminFee,
  } = vehicle

  const title = `${make} ${selectedModel}`

  const image: string = thumbnailUrl
    ? thumbnailUrl.replace(/0-(.*)-thumbnail\.([a-z]+)$/, '1-$1.$2')
    : ''

  const tags: { label: string; value: string }[] = getVehicleTags(vehicle)

  return (
    <ProductListCard
      id={vehicleId || id}
      price={price}
      priceIncludingAdminFee={priceIncludingAdminFee}
      image={image}
      title={title}
      subtitle={variant}
      tags={tags}
      isReserved={isReserved}
      quoteRegularPaymentInPence={quoteRegularPaymentInPence}
      quoteType={quoteType}
      make={make}
      model={selectedModel}
      vehicleYear={vehicleYear}
      discountInPence={discountInPence}
      {...props}
    />
  )
}

export default VehicleCard
